const EN = {
  'rvr.interior.image-1.hotspot-1.label': 'Steering & Dashboard',
  'rvr.interior.image-1.hotspot-1.message': 'Steering and dashboard',
  'rvr.interior.image-1.hotspot-2.label': 'Climate Control',
  'rvr.interior.image-1.hotspot-2.message': 'Climate control',
  'rvr.interior.image-1.hotspot-3.label': 'Gearshift &\nCenter Console',
  'rvr.interior.image-1.hotspot-3.message': 'Gearshift and center console',
  'rvr.interior.image-1.hotspot-4.label': "Driver's seat",
  'rvr.interior.image-1.hotspot-4.message': "Driver's seat",
  'rvr.interior.image-1.hotspot-5.label': 'Connectivity & Infotainment',
  'rvr.interior.image-1.hotspot-5.message': 'Connectivity and infotainment',

  'rvr.interior.image-2.hotspot-1.label': '2nd-Row Amenities',
  'rvr.interior.image-2.hotspot-1.message': '2nd-row amenities',
  'rvr.interior.image-2.hotspot-2.label': 'Leather Appointed Seats',
  'rvr.interior.image-2.hotspot-2.message': 'Leather appointed seats',
  'rvr.interior.image-2.hotspot-3.label': 'Active Safety Features',
  'rvr.interior.image-2.hotspot-3.message': 'Active safety features',
  'rvr.interior.image-2.hotspot-4.label': 'Seatbelts & Restraint Systems',
  'rvr.interior.image-2.hotspot-4.message': 'Seatbelts and restraint systems',

  'rvr.exterior.hotspot-1.label': 'Engine & Transmission',
  'rvr.exterior.hotspot-1.message': 'Engine and transmission',
  'rvr.exterior.hotspot-2.label': 'All-Wheel Control',
  'rvr.exterior.hotspot-2.message': 'All-Wheel Control',
  'rvr.exterior.hotspot-3.label': 'Wheels & Tires',
  'rvr.exterior.hotspot-3.message': 'Wheels and tires',
  'rvr.exterior.hotspot-4.label': 'Liftgate & Fuel Filler',
  'rvr.exterior.hotspot-4.message': 'Liftgate and fuel filler',
  'rvr.exterior.hotspot-5.label': 'Active Safety Features',
  'rvr.exterior.hotspot-5.message': 'Active safety features',

  'rvr.blueprint.safety.tab-1': 'Side-impact curtain airbags',
  'rvr.blueprint.safety.tab-2': 'Driver knee airbag',
  'rvr.blueprint.safety.tab-3': 'Dual front airbags',
  'rvr.blueprint.safety.tab-4': 'Front seat-mounted side-impact airbags',
  'rvr.blueprint.safety.hotspot-1.label': 'Side-impact curtain\nairbags (1st & 2nd row)',
  'rvr.blueprint.safety.hotspot-1.message': 'Side-impact curtain airbags (1st & 2nd row)',
  'rvr.blueprint.safety.hotspot-2.label': 'Driver knee airbag',
  'rvr.blueprint.safety.hotspot-2.message': 'Driver knee airbag',
  'rvr.blueprint.safety.hotspot-3.label': 'Dual front airbags',
  'rvr.blueprint.safety.hotspot-3.message': 'Dual front airbags',
  'rvr.blueprint.safety.hotspot-4.label': 'Front seat-mounted\nside-impact airbags',
  'rvr.blueprint.safety.hotspot-4.message': 'Front seat-mounted side-impact airbags',

  'rvr.launcher.introduction': 'Click to ask anything about the RVR',
}

export default EN
